import styles from "./checklist.module.css";

export const CategoryOpenIcon = ({
    isOpen,
    className,
}: {
    isOpen?: boolean;
    className?: string;
}) => (
    <div
        className={`${styles.openIconContainer} ${isOpen ? styles.openIconContainerOpen : ""} ${className ?? ""}`}
    >
        <svg
            className={`${styles.openIcon} ${isOpen ? styles.openIconOpen : ""}`}
            viewBox="0 0 10 10"
            aria-hidden="true"
        >
            <polygon points="2,7 8,7 5,2" />
        </svg>
    </div>
);
